import { API, graphqlOperation } from "aws-amplify";
import { updateProject } from "../../graphql/mutations";

const cleanParticipant = (participant) => ({
  email: typeof participant.email === "string" ? participant.email.trim() : participant.email,
  firstName: typeof participant.firstName === "string" ? participant.firstName.trim() : participant.firstName,
  lastName: typeof participant.lastName === "string" ? participant.lastName.trim() : participant.lastName,
  title: typeof participant.title === "string" ? participant.title.trim() : (participant.title || ""),
});

const RemoveParticipant = async (project, selectedParticipantId) => {
  try {
    const participantsCopy = (project.participants || []).map(cleanParticipant);
    participantsCopy.splice(selectedParticipantId, 1);
    await API.graphql(
      graphqlOperation(updateProject, {
        id: project.id,
        projectName: project.projectName,
        participants: participantsCopy
      })
    );
  } catch (error) {
    throw new Error("InternalServerError");
  }
};

export default RemoveParticipant;
